import { render, staticRenderFns } from "./affordability.vue?vue&type=template&id=5742ae91&scoped=true&"
import script from "./affordability.vue?vue&type=script&lang=js&"
export * from "./affordability.vue?vue&type=script&lang=js&"
import style0 from "./affordability.vue?vue&type=style&index=0&id=5742ae91&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5742ae91",
  null
  
)

export default component.exports